
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recovery",
      function () {
        return require("private-next-pages/recovery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recovery"])
      });
    }
  